export const DEFAULTS = {
  progressPoolA: 0,
  progressPoolB: 0,
  maxFlagAlpha: 1,
  flagAlpha: 1,
  flagBrightnessMix: 0,
  zoom: 0,
  background: 0,
  videoAlpha: 1,
  videoZ: -45.0,
  dissolve: 0,
  videoColorMix: 0,
  flagOverlay: 0
};

export const INTRO_TARGET = {
  progressPoolA: 1,
  progressPoolB: 0,
  flagBrightnessMix: 0.12,
  zoom: 0,
  videoAlpha: 1,
  videoZ: 0.18,
  videoColorMix: 1,
  flagOverlay: 0
};

export const DEFAULTS_ABOUT = {
  progressPoolA: 0.2,
  progressPoolB: 0,
  maxFlagAlpha: 1,
  flagAlpha: 0,
  flagBrightnessMix: 1,
  zoom: 0.7,
  background: 1,
  videoAlpha: 0,
  videoZ: 0,
  dissolve: 0.3,
  videoColorMix: 1,
  flagOverlay: 0
};

export const ABOUT_TARGET = {
  progressPoolA: 1,
  background: 0,
  zoom: 0.05,
  dissolve: 0,
  progress: 0.7,
  flagBrightnessMix: 0.08,
  flagAlpha: 1
};
